export default __webpack_public_path__ + "static/media/Fashionista.64e2a909.ttf";